<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import * as XLSX from 'xlsx';

import Socket from "@/utils/Socket";
import NMPrintSocket from "@/utils/Print";
import { textPrintData } from "@/utils/printData/Text";
import { barcodePrintData } from "@/utils/printData/Barcode";
import { qrCodePrintData } from "@/utils/printData/QrCode";
import { linePrintData } from "@/utils/printData/Line";
import { graphPrintData } from "@/utils/printData/Graph";
import { imgPrintData } from "@/utils/printData/Img";
import { combinationPrintData } from "@/utils/printData/Combination";
import { batchPrintData } from "@/utils/printData/Batch";
import { toApiLanguage } from "@/utils/locale";
import { currencyUnitLabel } from "@/utils/currency";

/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Starter page",
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Starter page",
          active: true,
        },
      ],
      userinfo: [],
      ismobile: false,
      orderpage: 1,
      orderarray: [],
      devicespage: 1,
      devicesearch: "",
      ordersearch: "",
      orderpaystatus: -1,
      orderpaytype: -1,
      ordertimes: [],
      allcount: 0,
      pickerOptions: {},
      datacount: 0,
      allpage: 0,
      activeapp: [],
      block: false,
      loading: true,
      empty: true,
      limit: 10,
      systemtype: 0,
      globalCurrey: "CNY",
      ordersettingdialog: false,
      ordersettingvalue: {},
      autorefreshdata: {
        status: false,
        task: "",
      },
      timer: 60,
      exceljson: [],
      // 标签打印机
      jsonObj: {
        printerImageProcessingInfo: {
          printQuantity: 2,
        },
      },
      // 打印服务实例（新增）
      socketData: null,
      // 打印监听（新增）
      unsubscribe: null,
      // 打印是否错误（新增）
      isPrintError: false,
      // 打印服务是否连接成功
      printSocketOpen: false,
      nMPrintSocket: null,
      usbPrinters: {},
      wifiPrinters: {},
      onlineUsbBool: false,
      onlineWifiBool: false,
      usbSelectPrinter: "",
      wifiSelectPrinter: "",
      initBool: false,
      density: 3,
      label_type: 1,
      print_mode: 1,
      auto_shut_down: 1,
      wifiName: "",
      wifiPassword: "",
      labelprinter: {
        loading: true,
        enable: false
      },
      dialogOrderV3QrForm: false,
      orderv3form: {
        time: [],
        price: 0,
      },
      v3formtimeOption: {
        shortcuts: [{
          text: '1小时',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '3小时',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 3);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '5小时',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(end.getTime() + 3600 * 1000 * 5);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      userid: 0,
      paymentTypes: [
        { value: -1, label: this.$t("device.orders.allstatus") },
        { value: 0, label: this.$t("device.orders.coinpay") },
        { value: 1, label: this.$t("device.orders.useramount") },
        { value: 2, label: this.$t("device.orders.alipay") },
        { value: 3, label: this.$t("device.orders.wxpay") },
        { value: 4, label: this.$t("device.orders.payment.applepay") },
        { value: 5, label: this.$t("device.orders.payment.googlewallet") },
        { value: 6, label: this.$t("device.orders.payment.amazonpay") },
        { value: 7, label: this.$t("device.orders.payment.qpay") },
        { value: 40, label: this.$t("device.orders.payment.bestpay") },
        { value: 41, label: this.$t("device.orders.payment.sandpay") },
        { value: 42, label: this.$t("device.orders.payment.paymentasia") },
        { value: 61, label: this.$t("device.orders.payment.nayax") },
        { value: 77, label: this.$t("device.orders.payment.coin") }
      ],
      selectedPaymentTypes: [-1],
      orderStatus: [
        { value: -1, label: this.$t("device.orders.allstatus") },
        { value: 0, label: this.$t("device.orders.nopay") },
        { value: 1, label: this.$t("device.orders.orderpay") },
        { value: 3, label: this.$t("device.orders.refuntrue") }
      ],
      selectedOrderStatus: -1,
    };
  },
  mounted() {
    var that = this;
    that.title = that.$t("menuitems.devices.orders");
    that.items = [
      {
        text: that.$t("menuitems.devices.text"),
        href: "/",
      },
      {
        text: that.$t("menuitems.devices.orders"),
        active: true,
      },
    ];
    //   this.getdevicelist()
    that.userinfo = JSON.parse(localStorage.getItem("user"));
    {
      const rid = parseInt(
        that.userinfo.roleid != null
          ? that.userinfo.roleid
          : that.userinfo.roleId,
        10
      );
      if (Number.isFinite(rid) ? rid !== 0 : parseInt(that.userinfo.topuid, 10) >= 1) {
        that.block = true;
      }
    }
    let flag = navigator.userAgent.match(
      /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      // that.ismobile = true;
    }
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth();
    let dd = new Date().getDate();
    mm = mm + 1;
    const endDate = new Date(yy, mm - 1, dd);
    const startDate = new Date(yy, mm - 1, dd);
    startDate.setDate(startDate.getDate() - 1);
    const fmtOrderDate = (d) => d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate();
    that.ordertimes = [fmtOrderDate(startDate), fmtOrderDate(endDate)];
    that.pickerOptions = {
      shortcuts: [
        {
          text: that.$t("device.orders.oneday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: that.$t("device.orders.oneweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: that.$t("device.orders.onemonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: that.$t("device.orders.threemonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          },
        },
      ],
    };
    that.userid = that.userinfo.id;
    that.getorderlist();
    that.getsysteminfo();


  },
  computed: {
    searchinorderlist() {
      var paycode = {
        wxpay: 3,
        alipay: 2,
      };
      var datas = this.orderarray.filter((value) => {
        return (
          !this.ordersearch ||
          value.ED_id.toLowerCase().includes(
            this.ordersearch.trim().toLowerCase()
          ) ||
          !this.ordersearch ||
          value.ED_name.toLowerCase().includes(
            this.ordersearch.trim().toLowerCase()
          ) ||
          !this.ordersearch ||
          value.sn.toLowerCase().includes(this.ordersearch.trim().toLowerCase())
        );
      });
      if (this.orderpaystatus >= 0) {
        if (
          this.orderpaystatus == 0 ||
          this.orderpaystatus == 1 ||
          this.orderpaystatus == 3
        ) {
          datas = datas.filter((value) => {
            return value.status == this.orderpaystatus;
          });
        }
      }
      if (this.orderpaytype >= 0) {
        datas = datas.filter((value) => {
          return value.payway == this.orderpaytype;
        });
      }
      return datas;
    },
  },
  methods: {
    getsysteminfo() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "systeminfo",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          var d = response.data.data;
          that.systemtype = parseInt(d.model);
          if (d.currey) {
            that.globalCurrey = d.currey;
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    currencyLabel(code) {
      return currencyUnitLabel(this, code || this.globalCurrey);
    },
    getorderlist: function () {
      var that = this;
      that.orderarray = [];
      var date = that.ordertimes[0] + "," + that.ordertimes[1];
      that.orderlistloading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "orderlist",
            page: that.orderpage,
            date: date,
            limit: that.limit,
            uid: that.userid,
            paycode: that.selectedPaymentTypes,
            status: that.selectedOrderStatus,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          var data = response.data;
          if (data.currey) {
            that.globalCurrey = data.currey;
          }
          if (data.count > 0) {
            that.orderarray = data.data;
            that.datacount = data.count;
            that.allpage = data.allpage;
            that.allcount = data.total;
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    dropdown: function (command) {
      this.downloadexceljson(command);
    },
    downloadexceljson(type) {
      var that = this;
      var date = that.ordertimes[0] + "," + that.ordertimes[1];
      that.orderlistloading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "dump_orderlist_json",
            date: date,
            type: type,
            language: toApiLanguage(that.$i18n.locale),
            uid: that.userid,
            paycode: that.selectedPaymentTypes,
            status: that.selectedOrderStatus,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(async function (response) {
          var jsonData = response.data.table || [];
          const headers = [
            that.$t("orders.table.ordersn"),
            that.$t("orders.table.ED_id"),
            that.$t("orders.table.ED_name"),
            that.$t("orders.table.total"),
            that.$t("orders.table.value"),
            that.$t("orders.table.goodsname"),
            that.$t("orders.table.createtime"),
            that.$t("orders.table.paytime"),
            that.$t("orders.table.payway"),
            that.$t("orders.table.status"),
            that.$t("orders.table.delete"),
            that.$t("orders.table.user"),
            that.$t("orders.table.phone")
          ];
          const rows = jsonData.map(function (row) {
            return [
              row.sn,
              row.ED_id,
              row.ED_name,
              row.total,
              row.goodstotal,
              row.goodsname || row.title || "",
              row.addtime,
              row.paytime,
              row.payway,
              row.status,
              row.isdel,
              row.username,
              row.phone
            ];
          });
          const worksheet = XLSX.utils.aoa_to_sheet([headers].concat(rows));
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          const exportDate = new Date();
          const year = exportDate.getFullYear();
          const month = exportDate.getMonth() + 1;
          const day = exportDate.getDate();
          XLSX.writeFile(workbook, that.$t("menuitems.devices.orders") + `_${year}${month}${day}` + "_tableData.xlsx");
        })
        .catch(function (error) {
          // console.log(error);
        })
        .finally(function () {
          that.orderlistloading = false;
        });
    },
    // downloadtable: function(){
    //   const workbook = XLSX.utils.book_new();
    //   const worksheet = XLSX.utils.json_to_sheet(this.orderarray);
    //   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //   XLSX.writeFile(workbook, "order.xlsx");

    // },
    logdata: function (route, id) {
      var that = this;
      if (route == "order") {
        that.$toast.loading({
          message: that.$t("global.loading.readingv2"),
          forbidClick: true,
        });
        that.$axios
          .get("https://doc.aic.pet/" + id + ".orderlog")
          .then((response) => {
            that.$toast.clear();
            window.location.href = response.data.file;
          });
      }
    },
    handleSizeChange(val) {
      this.limit = val;
      this.getorderlist();
    },
    handleCurrentChange(val) {
      this.orderpage = val;
      this.getorderlist();
    },
    deletes(type, id) {
      var that = this;
      that
        .$confirm(
          that.$t("global.delete.deleteordertip"),
          that.$t("global.delete.sureyouaction"),
          {
            confirmButtonText: that.$t("global.button.ok"),
            cancelButtonText: that.$t("global.button.cancel"),
            type: "warning",
          }
        )
        .then(() => {
          that.$axios
            .post(
              that.apiuri,
              {
                action: "delete",
                type: type,
                id: id,
              },
              {
                headers: { Openid: that.userinfo.openid },
              }
            )
            .then(function (response) {
              if (response.data.status == 200) {
                that.$message({
                  message: that.$t("global.delete.success"),
                  type: "success",
                });
              } else if (response.data.status == 403) {
                that.$message({
                  message: that.$t("global.delete.auth"),
                  type: "warning",
                });
              } else {
                that.$message.error(that.$t("global.delete.500"));
              }
              that.getorderlist();
            })
            .catch(function (error) {
              // console.log(error);
            });
        })
        .catch(() => { });
    },
    refund(orderid) {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "refunpay",
            orderid: orderid,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status == 200) {
            that.$message({
              message: that.$t("global.success"),
              type: "success",
            });
          } else if (response.data.status == 202 || response.data.status == 508) {
            that.$message({
              message: that.$t(response.data.msg),
              type: "warning",
            });
          } else if (response.data.status == 403) {
            that.$message({
              message: that.$t("global.delete.auth"),
              type: "warning",
            });
          } else {
            that.$message.error(that.$t("global.delete.500"));
          }
          that.getorderlist();
        })
        .catch(function (error) {
          // console.log(error);
        });

    },
    autorefresh(status) {
      if (status) {
        this.autorefreshdata.task = setInterval(() => {
          this.getorderlist();
        }, this.timer * 1000);
      } else {
        clearInterval(this.autorefreshdata.task);
      }
    }
  },
  filters: {
    formatTimer: function (value) {
      value = value * 1000;
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card" v-loading="loading">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div>
                  <label for="orderdays">{{
                    $t("device.orders.ordertime")
                  }}</label>
                  <div class="row">
                    <el-date-picker v-model="ordertimes" type="daterange" align="right" unlink-panels
                      format="yyyy/MM/dd" value-format="yyyy/MM/dd" :range-separator="$t('device.orders.to')"
                      :start-placeholder="$t('device.orders.begindate')" :end-placeholder="$t('device.orders.enddate')"
                      :picker-options="pickerOptions">
                    </el-date-picker>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div>
                  <label for="orderdays">{{
                    $t("device.orders.orderstatus")
                  }}</label>
                  <div class="row">
                    <el-select v-model="selectedOrderStatus" placeholder="请选择">
                      <el-option v-for="item in orderStatus" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div>
                  <label for="orderdays">{{
                    $t("device.orders.paytype")
                  }}</label>
                  <div class="row">
                    <el-select v-model="selectedPaymentTypes" multiple placeholder="请选择">
                      <el-option v-for="item in paymentTypes" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div style="margin-left: 15px">
                  <label for="orderdays">{{
                    $t("device.orders.action")
                  }}</label>
                  <div class="row">
                    <el-button type="primary" @click="getorderlist()" icon="el-icon-search">{{ $t("device.lists.search")
                    }}</el-button>
                    <el-dropdown split-button @command="dropdown" @click="downloadexceljson(0)" trigger="click">
                      {{ $t("device.lists.excel") }}
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">{{
                          $t("device.lists.excelreg")
                        }}</el-dropdown-item>
                        <el-dropdown-item command="2">{{
                          $t("device.lists.excelnonereg")
                        }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
              <div class="col-md-1">
                <div>
                  <label for="orderdays">
                    {{ $t("device.orders.autorefresh") }}
                  </label>
                  <div class="row">
                    <el-switch v-model="autorefreshdata.status" :inactive-text="$t('global.close')"
                      :active-text="$t('global.open')" @change="autorefresh" />
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div>
                  <label for="keyword">{{ $t("device.orders.keyword") }}</label>
                  <div class="row">
                    <input type="text" class="form-control" v-model="ordersearch"
                      :placeholder="$t('device.orders.searchorder')" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body" style="overflow-x: auto; overflow-y: hidden">
            <table id="deviceslist_table" class="table table-striped">
              <thead>
                <tr>
                  <th class="sortStyle">{{ $t("device.orders.orderid") }}</th>
                  <th class="sortStyle" v-if="systemtype == 0">
                    {{ $t("device.orders.goodsname") }}
                  </th>
                  <th class="sortStyle">
                    {{ $t("device.orders.salsevalues") }}
                  </th>
                  <th class="sortStyle">
                    {{ $t("device.orders.orderprice") }}
                  </th>
                  <th class="sortStyle" v-if="systemtype == 0">
                    {{ $t("device.orders.paytype") }}
                  </th>
                  <th class="sortStyle" v-if="systemtype != 1">
                    {{ $t("device.orders.orderstatus") }}
                  </th>
                  <th class="sortStyle" v-if="systemtype == 2">
                    {{ $t("device.orders.user") }}
                  </th>
                  <th class="sortStyle">{{ $t("device.orders.ordertime") }}</th>
                  <th class="sortStyle">{{ $t("device.orders.deviceid") }}</th>
                  <th class="sortStyle">{{ $t("device.orders.action") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!searchinorderlist || orderarray.length == 0">
                  <td colspan="9">
                    <el-empty :description="$t('device.orders.nodata')"></el-empty>
                  </td>
                </tr>
                <tr v-for="(val, idx) in searchinorderlist" :class="'device' + val.id" :key="val.id">
                  <td>
                    <span :id="val.sn">{{ val.shid }}</span>
                    <b-tooltip :target="val.sn">{{ val.sn }}</b-tooltip>
                  </td>
                  <td v-if="systemtype == 0 && val.goods">{{ val.goods }}</td>
                  <td v-if="systemtype == 0 && !val.goods">
                    {{ $t("device.orders.nogoodsname") }}
                  </td>

                  <td>
                    {{ val.goodstotal }}
                    <span v-if="val.ED_id.substring(0, 4) == 7710">
                      {{ $t("device.orders.pack") }}</span>
                    <span v-else>ML</span>
                  </td>
                  <td>
                    {{ val.total }} {{ currencyLabel() }}
                    <span v-if="val.refun_fee > 0 && val.status == 3">({{ $t("device.orders.status.refund_price")
                    }}:{{ val.refun_fee }} {{ currencyLabel() }})</span>
                    <span v-if="val.refun_fee > 0 && val.status == 1">({{ $t("device.orders.status.discount_price")
                    }}:{{ val.refun_fee }} {{ currencyLabel() }})</span>
                  </td>
                  <td v-if="systemtype == 0">
                    <span v-if="val.payway == 0"><i class="ri-wallet-line"></i>{{ $t("device.orders.payment.cash")
                    }}</span>
                    <span v-if="val.payway == 1"><i class="ri-wallet-line"></i>{{ $t("device.orders.payment.wallet")
                    }}</span>
                    <span v-if="val.payway == 2"><i class="fab fa-alipay" style="color: #4dabf7"></i>{{
                      $t("device.orders.payment.alipay") }}</span>
                    <span v-if="val.payway == 3"><i class="fab fa-weixin" style="color: #3cb034"></i>{{
                      $t("device.orders.payment.wxpay") }}</span>
                    <span v-if="val.payway == 4"><i class="fab fa-apple-pay"></i>{{ $t("device.orders.payment.applepay")
                    }}</span>
                    <span v-if="val.payway == 5"><i class="fab fa-google-wallet"></i>{{
                      $t("device.orders.payment.googlewallet") }}</span>
                    <span v-if="val.payway == 6"><i class="fab fa-amazon-pay"></i>{{
                      $t("device.orders.payment.amazonpay")
                    }}</span>
                    <span v-if="val.payway == 7"><i class="fab fa-qq"></i>{{ $t("device.orders.payment.qpay") }}</span>
                    <span v-if="val.payway == 40"><i class="fab fa-bestpay"></i>{{ $t("device.orders.payment.bestpay")
                    }}</span>
                    <span v-if="val.payway == 41"><i class="fab fa-sandpay"></i>{{ $t("device.orders.payment.sandpay")
                    }}</span>
                    <span v-if="val.payway == 61"><i class="fab fa-nyax"></i>{{ $t("device.orders.payment.nayax")
                    }}</span>
                  </td>
                  <td v-if="systemtype != 1">
                    <label class="badge badge-secondary" v-if="val.paytime > 0 && val.refun_fee == 0">{{
                      $t("device.orders.status.orderpay") }}</label>
                    <label class="badge badge-danger" v-if="val.paytime == 0">{{
                      $t("device.orders.status.nopay")
                    }}</label>
                    <label class="badge badge-danger" v-if="val.feedback == 6 && systemtype != 2">{{
                      $t("device.orders.status.devicedown") }}</label>
                    <label class="badge badge-danger" v-if="val.feedback == 2 && systemtype != 2">{{
                      $t("device.orders.status.returnfalse") }}</label>
                    <label class="badge badge-info" v-if="val.feedback == 3">{{
                      $t("device.orders.status.beersurpgoods")
                    }}</label>
                    <label class="badge badge-warning" v-if="val.feedback == 7 &&
                      val.paytime > 0 &&
                      val.refun_fee == 0 &&
                      systemtype != 2
                    ">{{ $t("device.orders.status.serversenddone") }}</label>
                    <label class="badge badge-success" v-if="val.feedback == 1 &&
                      val.paytime > 0 &&
                      val.refun_fee == 0 &&
                      systemtype != 2
                    ">{{ $t("device.orders.status.pushdone") }}</label>
                    <!--例外-->
                    <label class="badge badge-success" v-if="val.feedback == 3 &&
                      val.paytime > 0 &&
                      val.refun_fee == 0 &&
                      val.ED_id == 750004340001
                    ">{{ $t("device.orders.status.pushdone") }}</label>
                    <label class="badge badge-success" v-if="val.feedback == 10 &&
                      val.paytime > 0 &&
                      val.refun_fee == 0
                    ">{{ $t("device.orders.status.dropbag_error") }}</label>
                    <label class="badge badge-success" v-if="val.feedback == 11 &&
                      val.paytime > 0 &&
                      val.refun_fee == 0
                    ">{{ $t("device.orders.status.getcup_error") }}</label>
                    <label class="badge badge-success" v-if="val.feedback == 12 &&
                      val.paytime > 0 &&
                      val.refun_fee == 0
                    ">{{ $t("device.orders.status.flow_error") }}</label>

                    <label class="badge badge-warning" v-if="val.refun_fee > 0 && val.status == 3">{{
                      $t("device.orders.status.refuntrue")
                    }}</label>
                    <label class="badge badge-warning" v-if="val.refun_fee > 0 && val.status == 1">{{
                      $t("device.orders.status.orderpay")
                    }}</label>
                  </td>
                  <td v-if="systemtype == 2">
                    <span v-if="val.uid > 0 && val.user">{{ val.user }}</span>
                    <span v-else-if="val.uid > 0 && !val.user">{{
                      $t("device.order.usernotfound")
                    }}</span>
                    <span v-else>
                      <span v-if="val.user">{{
                        $t("device.order.grouppay", { group: val.user })
                      }}</span>
                      <span v-else>
                        <span v-if="val.payway == 0"><i class="ri-wallet-line"></i>{{ $t("device.orders.payment.cash")
                        }}</span>
                        <span v-if="val.payway == 1"><i class="ri-wallet-line"></i>{{ $t("device.orders.payment.wallet")
                        }}</span>
                        <span v-if="val.payway == 2"><i class="fab fa-alipay" style="color: #4dabf7"></i>{{
                          $t("device.orders.payment.alipay") }}</span>
                        <span v-if="val.payway == 3"><i class="fab fa-weixin" style="color: #3cb034"></i>{{
                          $t("device.orders.payment.wxpay") }}</span>
                        <span v-if="val.payway == 4"><i class="fab fa-apple-pay"></i>{{
                          $t("device.orders.payment.applepay") }}</span>
                        <span v-if="val.payway == 5"><i class="fab fa-google-wallet"></i>{{
                          $t("device.orders.payment.googlewallet") }}</span>
                        <span v-if="val.payway == 6"><i class="fab fa-amazon-pay"></i>{{
                          $t("device.orders.payment.amazonpay") }}</span>
                        <span v-if="val.payway == 7"><i class="fab fa-qq"></i>{{ $t("device.orders.payment.qpay")
                        }}</span>
                        <span v-if="val.payway == 40"><i class="fab fa-bestpay"></i>{{
                          $t("device.orders.payment.bestpay")
                        }}</span>
                        <span v-if="val.payway == 41"><i class="fab fa-sandpay"></i>{{
                          $t("device.orders.payment.sandpay")
                        }}</span>
                        <span v-if="val.payway == 42">{{ $t("device.orders.payment.paymentasia")
                        }}</span>
                        <span v-if="val.payway == 61"><i class="fab fa-nyax"></i>{{ $t("device.orders.payment.nayax")
                        }}</span>
                        <span v-if="val.payway == 77">{{ $t("device.orders.payment.coin") }}</span>
                      </span>
                    </span>
                  </td>
                  <td v-if="val.paytime > 0">
                    {{ val.paytime | formatTimer }}
                  </td>
                  <td v-if="val.paytime == 0">
                    {{ val.addtime | formatTimer }}
                  </td>
                  <td>
                    <span :id="'orderid' + idx">{{ val.ED_id }}</span>
                    <b-tooltip :target="'orderid' + idx">{{
                      val.ED_name
                    }}</b-tooltip>
                  </td>
                  <td>
                    <router-link :to="{
                      path: '/device/orderdetail',
                      query: { id: val.id },
                    }">
                      <a class="btn btn-info rounded-pill">
                        {{ $t("device.orders.button.info") }}
                      </a>
                    </router-link>
                    <a class="btn btn-dark rounded-pill" @click="deletes('order', val.id)" v-if="!block">
                      {{ $t("device.orders.button.delete") }}
                    </a>
                    <a class="btn btn-info rounded-pill" @click="refund(val.id)" v-if="val.refund_button == 1">
                      {{ $t("device.orders.button.refund") }}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="text-center">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="allcount">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style></style>